import TicketDetails from './TicketDetails';
import TicketList from './TicketList';

const Tickets = () => {
  return (
    <div className="flex h-full w-full flex-col gap-2 md:flex-row">
      {/* BOX 1 */}
      <div className="flex h-full w-full md:w-1/2 lg:w-2/5">
        <TicketList />
      </div>

      {/* BOX 2 */}
      <div className="flex h-full w-full md:w-1/2 lg:w-3/5">
        <TicketDetails />
      </div>
    </div>
  );
};

export default Tickets;
